import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	developmentTask: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.development-task',
		defaultMessage: 'Angled brackets',
		description: 'Accessible name for development task avatar.',
	},
	feedback: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.feedback',
		defaultMessage: 'Light bulb',
		description: 'Accessible name for feedback avatar.',
	},
	requestAccess: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.request-access',
		defaultMessage: 'Lock',
		description: 'Accessible name for generic issue avatar. The icon looks like a padlock',
	},
	genericIssue: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.generic-issue',
		defaultMessage: 'Ring',
		description: 'Accessible name for generic issue avatar.',
	},
	bug: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.bug',
		defaultMessage: 'Dot',
		description: 'Accessible name for bug avatar.',
	},
	defect: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.defect',
		defaultMessage: 'Graph',
		description: 'Accessible name for defect avatar.',
	},
	documentation: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.documentation',
		defaultMessage: 'Document',
		description: 'Accessible name for documentation avatar.',
	},
	epic: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.epic',
		defaultMessage: 'Bolt',
		description: 'Accessible name for epic avatar.',
	},
	exclamation: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.exclamation',
		defaultMessage: 'Exclamation mark',
		description: 'Accessible name for exclamation avatar.',
	},
	designTask: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.design-task',
		defaultMessage: 'Heart',
		description: 'Accessible name for design task avatar.',
	},
	improvement: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.improvement',
		defaultMessage: 'Up arrow',
		description: 'Accessible name for improvement avatar.',
	},
	newFeature: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.new-feature',
		defaultMessage: 'Plus sign',
		description: 'Accessible name for new feature avatar.',
	},
	removeFeature: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.remove-feature',
		defaultMessage: 'Minus sign',
		description: 'Accessible name for remove feature avatar.',
	},
	requirement: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.requirement',
		defaultMessage: 'Tick',
		description: 'Accessible name for requirement avatar.',
	},
	sales: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.sales',
		defaultMessage: 'Dollar sign',
		description: 'Accessible name for sales avatar.',
	},
	story: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.story',
		defaultMessage: 'Bookmark',
		description: 'Accessible name for story avatar.',
	},
	subtask: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.subtask',
		defaultMessage: 'Squares',
		description: 'Accessible name for subtask avatar.',
	},
	task: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.task',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Checkmark',
		description: 'Accessible name for task avatar.',
	},
	question: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.question',
		defaultMessage: 'Question mark',
		description: 'Accessible name for question avatar.',
	},
	incident: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.incident',
		defaultMessage: 'Filled triangle with a circle between',
		description: 'Accessible name for incident avatar.',
	},
	notes: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.notes',
		defaultMessage: 'Notebook with pencil',
		description: 'Accessible name for notes avatar.',
	},
	envelope: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.envelope',
		defaultMessage: 'Envelope',
		description: 'Accessible name for envelope avatar.',
	},
	issueTypePerson: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.issue-type-person',
		defaultMessage: 'Person',
		description: 'Accessible name for issue type person avatar.',
	},
	issueTypeDocument: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.issue-type-document',
		defaultMessage: 'Page with earmark',
		description: 'Accessible name for issue type document avatar.',
	},
	issueTypeOrder: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.issue-type-order',
		defaultMessage: 'Dollar sign',
		description: 'Accessible name for issue type order avatar.',
	},
	issueTypeProperty: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.issue-type-property',
		defaultMessage: 'Diamond',
		description: 'Accessible name for issue type property avatar.',
	},
	issueTypeLead: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.issue-type-lead',
		defaultMessage: 'Plus sign',
		description: 'Accessible name for issue type lead avatar.',
	},
	issueTypeClaim: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.issue-type-claim',
		defaultMessage: 'Plus sign with shield',
		description: 'Accessible name for issue type claim avatar.',
	},
	projectAvatarAlien: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-alien',
		defaultMessage: 'One-eyed alien in spaceship',
		description: 'Accessible name for project avatar alien.',
	},
	projectAvatarParrot: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-parrot',
		defaultMessage: 'Smiling bird with yellow beak',
		description: 'Accessible name for project avatar parrot.',
	},
	projectAvatarCloud: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-cloud',
		defaultMessage: 'Happy cloud',
		description: 'Accessible name for project avatar cloud.',
	},
	projectAvatarDisc: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-disc',
		defaultMessage: 'Vinyl record',
		description: 'Accessible name for project avatar disc.',
	},
	projectAvatarCode: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-code',
		defaultMessage: 'Computer browser',
		description: 'Accessible name for project avatar code.',
	},
	projectAvatarCoffee: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-coffee',
		defaultMessage: 'Coffee cup',
		description: 'Accessible name for project avatar coffee.',
	},
	projectAvatarDesign: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-design',
		defaultMessage: 'Painting of landscape resting on easel',
		description: 'Accessible name for project avatar design.',
	},
	projectAvatarDrill: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-drill',
		defaultMessage: 'Yellow electric drill',
		description: 'Accessible name for project avatar drill.',
	},
	projectAvatarFood: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-food',
		defaultMessage: 'Hot dog with mustard',
		description: 'Accessible name for project avatar food.',
	},
	projectAvatarKoala: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-koala',
		defaultMessage: 'Smiling koala eating leaf',
		description: 'Accessible name for project avatar koala.',
	},
	projectAvatarMobile: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-mobile',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Smartphone with smiley face',
		description: 'Accessible name for project avatar mobile.',
	},
	projectAvatarMoney: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-money',
		defaultMessage: 'Wallet with money sticking out',
		description: 'Accessible name for project avatar money.',
	},
	projectAvatarWebsite: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-website',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Computer browser with cursor in centre',
		description: 'Accessible name for project avatar website.',
	},
	projectAvatarNature: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-nature',
		defaultMessage: 'Snow-capped mountains with sun behind',
		description: 'Accessible name for project avatar nature.',
	},
	projectAvatarNotes: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-notes',
		defaultMessage: 'Notebook with pencil',
		description: 'Accessible name for project avatar notes.',
	},
	projectAvatarPlane: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-plane',
		defaultMessage: 'Airplane flying skyward',
		description: 'Accessible name for project avatar plane.',
	},
	projectAvatarPower: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-power',
		defaultMessage: 'Purple and orange battery with plus symbol',
		description: 'Accessible name for project avatar power.',
	},
	projectAvatarFlag: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-flag',
		defaultMessage: 'Red flag on pole',
		description: 'Accessible name for project avatar flag.',
	},
	projectAvatarRefresh: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-refresh',
		defaultMessage: 'Two circular arrows representing refresh icon',
		description: 'Accessible name for project avatar refresh.',
	},
	projectAvatarRocket: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-rocket',
		defaultMessage: 'Rocket flying through space',
		description: 'Accessible name for project avatar rocket.',
	},
	projectAvatarScience: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-science',
		defaultMessage: 'Science bottle full of bubbling red liquid',
		description: 'Accessible name for project avatar science.',
	},
	projectAvatarSettings: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-settings',
		defaultMessage: 'Settings control panel with vertical sliders',
		description: 'Accessible name for project avatar settings.',
	},
	projectAvatarSpanner: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-spanner',
		defaultMessage: 'Silver wrench',
		description: 'Accessible name for project avatar spanner.',
	},
	projectAvatarStorm: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-storm',
		defaultMessage: 'Storm cloud with rain and lightning',
		description: 'Accessible name for project avatar storm.',
	},
	projectAvatarSupport: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-support',
		defaultMessage: 'Red and white life buoy on blue background',
		description: 'Accessible name for project avatar support.',
	},
	projectAvatarYeti: {
		id: 'project-settings-apps.avatar-modal.accessible-avatar-names.project-avatar-yeti',
		defaultMessage: 'Frowning abominable snowman',
		description: 'Accessible name for project avatar yeti.',
	},
});
